import { Button } from '@mui/material';
import { useRef, useState } from 'react';
import { useNavigate } from 'react-router';

import { toast } from 'sonner';
import { useUserPermissions } from 'src/hooks/useUserPermissions';
import { useGetPieceAutoActionsConflictsCountQuery } from 'src/redux/api/pieceAutoActions';
import { administrationRoutes } from 'src/routes/paths';
import { Roles } from 'src/types/shared';
import { getPlural } from 'src/utils/stringFormatters';

const TOAST_NAME = 'conflicts';

const AutomationConflictToast = () => {
  const [show, setShow] = useState(false);

  const conflicts = useRef<number>(undefined);

  const { isAllowed } = useUserPermissions();

  const isAdmin = isAllowed([Roles.Admin]);

  const { data: count } = useGetPieceAutoActionsConflictsCountQuery(undefined, { skip: !isAdmin });

  const navigate = useNavigate();

  if (conflicts.current !== count) {
    if (count && conflicts.current !== undefined && conflicts.current < count) {
      setShow(true);
    }

    if (count === 0) {
      setShow(false);
      toast.dismiss(TOAST_NAME);
    }

    conflicts.current = count;
  }

  return show && count && isAdmin
    ? toast.warning(`${count} Automation ${getPlural(count, 'conflict')} ${count === 1 ? 'exists' : 'exist'}`, {
        id: TOAST_NAME,
        duration: 100000000000,
        closeButton: false,
        style: {
          whiteSpace: 'nowrap',
          width: 'max-content',
          maxWidth: '1000px',
        },
        action: (
          <Button
            onClick={() => {
              toast.dismiss(TOAST_NAME);
              setShow(false);
            }}
            variant="outlined"
            size="small"
          >
            Dismiss
          </Button>
        ),
        cancel: (
          <Button
            onClick={() => {
              navigate(administrationRoutes.automationsConflicts);
              toast.dismiss(TOAST_NAME);
              setShow(false);
            }}
            variant="soft"
            color="warning"
            size="small"
          >
            Resolve
          </Button>
        ),
      })
    : null;
};

export default AutomationConflictToast;
